// extracted by mini-css-extract-plugin
export var container = "_cd-0";
export var content = "_cd-3";
export var customerTitle = "_cd-4";
export var empty = "_cd-5";
export var gray = "_cd-6";
export var header = "_cd-7";
export var info = "_cd-8";
export var loading = "_cd-2";
export var loadingCard = "_cd-9";
export var oneLine = "_cd-a";
export var personName = "_cd-e";
export var pillContainer = "_cd-b";
export var selected = "_cd-1";
export var text = "_cd-c";
export var twoLines = "_cd-d";
export var unread = "_cd-f";
export var unreadIndicator = "_cd-g";